import { Trans, useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();

  const disclaimer = true;
  return (
    <footer className="footer container">
      <p>{disclaimer && t('footer.disclaimer')}</p>
      <p>
        <Trans i18nKey="footer.credits">
          Powered by
          <a href={'https://www.liip.ch'} target={'_blank'}>
            Liip
          </a>
        </Trans>
      </p>
    </footer>
  );
};
